import { render, staticRenderFns } from "./BuyBoxFilterNew.vue?vue&type=template&id=f32096a2&scoped=true"
import script from "./BuyBoxFilterNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxFilterNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxFilterNew.vue?vue&type=style&index=0&id=f32096a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32096a2",
  null
  
)

export default component.exports